<template>
	<v-btn
		class="bot-btn-action button-rounding"
		dark
		@click="back"
		:small="small"
		:text="text"
		:outlined="outlined"
		:block="block"
	>
		<v-icon left>mdi-arrow-left-bold</v-icon>
		Volver
	</v-btn>
</template>

<script>
export default {
	props: {
		return_to: String,
		small: Boolean,
		text: Boolean,
		outlined: Boolean,
		block: Boolean,
	},
	methods: {
		back() {
			this.$store.commit(
				"chatStore/STATUS",
				this.return_to || this.$store.state.chatStore.prevStatus
			);
		},
	},
};
</script>
